import { render, staticRenderFns } from "./OfSelection.vue?vue&type=template&id=09f5ce4f&scoped=true"
import script from "./OfSelection.vue?vue&type=script&lang=js"
export * from "./OfSelection.vue?vue&type=script&lang=js"
import style0 from "./OfSelection.vue?vue&type=style&index=0&id=09f5ce4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f5ce4f",
  null
  
)

export default component.exports